import { render, staticRenderFns } from "./DodAddCustomerForm.vue?vue&type=template&id=0b9e7632&scoped=true&"
import script from "./DodAddCustomerForm.vue?vue&type=script&lang=js&"
export * from "./DodAddCustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./DodAddCustomerForm.vue?vue&type=style&index=0&id=0b9e7632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e7632",
  null
  
)

export default component.exports